import {getDate} from '../../../../../../@casino/lib/getDate';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { parseLogin } from '../../../../../../@casino/lib/parseLogin';

const useStyles = makeStyles(() => ({
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
}));

const rows = (users) => {
    return users.data.map((item) => {
        return {
            id: item.id,
            login: parseLogin(item.login),
            registration: getDate(+item.registration),
            last_cause_personal_bonuses: item.last_cause_personal_bonuses ? item.last_cause_personal_bonuses : '-',
            last_personal_bonuses: item.last_personal_bonuses ? item.last_personal_bonuses : '-',
            last_date_personal_bonuses: item.last_date_personal_bonuses ? getDate(+item.last_date_personal_bonuses) : '-'
        }
    })
}

const columns = [
    { id: 'id', label: 'ID игрока'},
    { id: 'login', label: 'Телефон, email или логин'},
    { id: 'registration', label: 'Дата регистрации игрока'},
    { id: 'last_cause_personal_bonuses', label: 'Причина выдачи последнего бонуса'},
    { id: 'last_personal_bonuses', label: 'Последний персональный бонус'},
    { id: 'last_date_personal_bonuses', label: 'Дата последнего выданого бонуса'}
];

export {
    useStyles,
    columns,
    rows
}
